import { useState, type ComponentProps, useCallback, useMemo } from "react";

import { NotificationList } from "./NotificationsList";

import { CLASS_CONSTANTS } from "@/utils/constants";
import type { FlashMessageDTO } from "@/store/api/dto/FlashMessage.dto";
import { useWidgetErrors } from "@/errors/useWidgetErrors";

export interface FlashNotificationsProps extends ComponentProps<"ul"> {
  flashNotifications?: FlashMessageDTO[];
  shouldScrollToRef?: boolean;
}

const stableFlashNotifications: FlashMessageDTO[] = [];

export const FlashNotifications = ({
  flashNotifications = stableFlashNotifications,
  shouldScrollToRef,
}: FlashNotificationsProps) => {
  const [removedNotification, removeNotification] = useState<
    FlashMessageDTO[]
  >([]);
  const failures = useWidgetErrors()?.failures;

  const filteredNotifications = useMemo(() => {
    return flashNotifications.filter((x) => !removedNotification.includes(x) &&
      !(x.level === "danger" && failures?.some(failure => failure.message === x.message)));
  }, [flashNotifications, removedNotification, failures]);

  const closeNotification = useCallback(
    (index: number) => {
      removeNotification((prev) => [...prev, filteredNotifications[index]]);
    },
    [filteredNotifications],
  );

  const notifications =
    filteredNotifications.length === 0 ? null : (
      <NotificationList
        className={CLASS_CONSTANTS.NOTIFICATION.FLASH}
        items={filteredNotifications}
        shouldScrollToRef={shouldScrollToRef}
        onClose={closeNotification}
      />
    );

  return <>{notifications}</>;
};

// const smartNotificationsFactory = () => {
//   const mapStateToProps = (state) => {
//     return {
//       flashNotifications: get(state.appReducer, "flashNotifications", []),
//     };
//   };

//   return connect(mapStateToProps, {
//     removeNotification,
//     sendFlashNotification,
//   })(FlashNotifications());
// };

// export const FlashNotifications = smartNotificationsFactory();
